import { Component, OnInit } from '@angular/core';
import { CommonModule, DecimalPipe, DatePipe } from '@angular/common';
import { TokenService } from 'src/app/core/services/token.service';
import { CbmService } from '../../../services/cbm.service';
import { ApiMessageService } from 'src/app/shared/services/api-message.service';
import { FlwService } from 'src/app/modules/flw/services/flw.service';
import { forkJoin } from 'rxjs';
import { SysService } from 'src/app/modules/sys/services/sys.service';
import { ImageUrlPipe } from "../../../../../pipe/image-url.pipe";

const ROWS_PER_PAGE = 14;
@Component({
  selector: 'app-transaction-status-report',
  imports: [CommonModule, ImageUrlPipe],
  templateUrl: './transaction-status-report.component.html',
  styleUrl: './transaction-status-report.component.scss'
})
export class TransactionStatusReportComponent implements OnInit {
  // ── State ─────────────────────────────────────────────────────────────────
  data: any | null = null;
  pages: any[] = [];

  // ── Totals ────────────────────────────────────────────────────────────────
  totalAmount = 0;
  totalTax = 0;
  totalNet = 0;
  totalInWords = '';
  currency = 'SAR';
  transactionId: any;
  userId: any;
  transaction: any;
  details: any;
  detailFileIndexes: any;
  error: any;
  history: any;
  groups: any[] = [];

  hasTags = false;

  // ── Primary transaction (first) ───────────────────────────────────────────
  get primaryTx(): any | null {
    return this.data?.transaction?.[0] ?? null;
  }

  // ── Today label ───────────────────────────────────────────────────────────
  today = new Date().toLocaleDateString('en-GB', {
    weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric',
  });

  // ── PDF generating flag ───────────────────────────────────────────────────
  generatingPdf = false;

  // ─────────────────────────────────────────────────────────────────────────

  constructor(
    private tokenService: TokenService,
    private cbmService: CbmService,
    private apiMessageService: ApiMessageService,
    private flwService: FlwService,
    private sysService: SysService
  ) {
    this.userId = this.tokenService.getUserIdFromToken()
  }
  ngOnInit(): void {
    let apiData: any | null = null;

    try {
      this.transactionId = sessionStorage.getItem('reportData');
      this.getConfigKeys()
      this.loadData();
      this.loadHistory();
    } catch (e) {
      console.error('Error parsing sessionStorage reportData', e);
    }
  }



  loadData(): void {
    const searchCriteria = {
      filter: null,
      pageSize: 1,
      currentPage: 1,
      totalCount: 0,
      data: {
        transactionId: this.transactionId,
        cashBookId: null,
        transactionDateFrom: null,
        transactionDateTo: null,
        cashBookTagIds: null,
        status: null,
        workflowCode: 'FLW_TRANSACTION_CREATION',
        userIdWorkflow: this.userId,
        hasWorkflowPermission: null
      }
    };

    this.cbmService.getTransactionDetails(searchCriteria).subscribe({
      next: (res) => {
        if (res.isSuccess && res.data) {
          res.data = res.data.data
          this.transaction = res.data.transactions?.[0] || null;
          this.details = (res.data.details || []).map((d: any) => ({ ...d, _expanded: false }));
        } else {
          this.error = res.message || 'Transaction not found';
        }
      },
      error: (err) => {
        this.error = 'Error loading transaction';
        this.apiMessageService.handleError(err);
      },
      complete: () => {
        this.data = {
          transaction: this.transaction,
          details: this.details
        };
        this.currency = this.transaction?.currencyNameEn ?? 'SAR';
        this.calcTotals(this.data);
        this.paginate(this.data);
      }
    });
  }

  companyName: any
  companyLogo: any
  getConfigKeys() {
    forkJoin({
      name: this.sysService.getConfigByKey('COMPANY_NAME'),
      logo: this.sysService.getConfigByKey('COMPANY_LOGO')
    }).subscribe(({ name, logo }) => {
      if (name.isSuccess) {
        this.companyName = name.data.configValue;
      }

      if (logo.isSuccess) {
        this.companyLogo = logo.data.configValue;
      }
    });
  }


  loadHistory() {
    const payload = {
      workflowCode: "FLW_TRANSACTION_CREATION",
      objectRowId: this.transactionId
    }
    this.flwService.getWorkflowExecutionHistory(payload).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.history = res.data.executionSteps
        }
      }, error: (err) => {
        this.error = 'Error loading History';
        this.apiMessageService.handleError(err);
      },
    })
  }

  get approvedHistory(): any[] {
    return (this.history ?? []).filter((s: any) => s.code === 'REVIEW_APPROVE');
  }

  totalTaxAmount: any


//   private buildGroups(details: any[]): any[] {
//   const r2 = (n: number) => Math.round(n * 100) / 100;
//   const map = new Map<number, any>();

//   for (const d of details) {
//     if (!map.has(d.tagId)) {
//       map.set(d.tagId, { tagId: d.tagId, tagName: d.tagNameEn, items: [], amount: 0, tax: 0, net: 0 });
//     }
//     const g = map.get(d.tagId);
//     g.items.push(d);
//     g.amount += d.amount ?? 0;
//     g.tax    += d.taxAmount ?? 0;
//     g.net    += d.netAmount ?? 0;
//   }

//   return [...map.values()].map(g => ({
//     ...g, count: g.items.length,
//     amount: r2(g.amount), tax: r2(g.tax), net: r2(g.net),
//   }));
// }

private buildGroups(details: any[]): any[] {
  const r2 = (n: number) => Math.round(n * 100) / 100;
  const NO_TAG = 0;
  const map = new Map<number, any>();

  for (const d of details) {
    const key = d.tagId || NO_TAG;

    if (!map.has(key)) {
      map.set(key, {
        tagId: key,
        tagName: key === NO_TAG ? 'No Tag' : d.tagNameEn,
        items: [], amount: 0, tax: 0, net: 0
      });
    }
    const g = map.get(key);
    g.items.push(d);
    g.amount += d.amount ?? 0;
    g.tax    += d.taxAmount ?? 0;
    g.net    += d.netAmount ?? 0;
  }

  return [...map.values()]
    .map(g => ({
      ...g, count: g.items.length,
      amount: r2(g.amount), tax: r2(g.tax), net: r2(g.net),
    }))
    
    .sort((a, b) => (a.tagId === NO_TAG ? 1 : 0) - (b.tagId === NO_TAG ? 1 : 0));
}


  // ── Calculations ──────────────────────────────────────────────────────────
  // private calcTotals(data: any): void {
  //   this.totalAmount = data.details.reduce(
  //     (s: any, d: any) => s + (d.amount ?? 0),
  //     0
  //   );

  //   this.totalTaxAmount = data.details.reduce(
  //     (s: any, d: any) => s + (d.localTaxAmount ?? 0),
  //     0
  //   );

  //   this.totalTax = data.transaction.taxAmount ?? 0;

  //   this.totalNet = data.transaction.netAmount ?? 0;

  //   this.totalInWords = this.numberToWords(this.totalNet);
  // }

//   private calcTotals(data: any): void {
//   this.groups = this.buildGroups(data.details);
//   const r2 = (n: number) => Math.round(n * 100) / 100;

//   // grand total = sum of all tag totals
//   this.totalAmount    = r2(this.groups.reduce((s, g) => s + g.amount, 0));
//   this.totalTaxAmount = r2(this.groups.reduce((s, g) => s + g.tax, 0));
//   this.totalNet       = r2(this.groups.reduce((s, g) => s + g.net, 0));

//   this.totalInWords = this.numberToWords(this.totalNet);
// }
private calcTotals(data: any): void {
  this.hasTags = data.details.some((d: any) => !!d.tagId);

  if (!this.hasTags) {
    // original totals
    this.totalAmount = data.details.reduce((s: any, d: any) => s + (d.amount ?? 0), 0);
    this.totalTaxAmount = data.details.reduce((s: any, d: any) => s + (d.localTaxAmount ?? 0), 0);
    this.totalTax = data.transaction.taxAmount ?? 0;
    this.totalNet = data.transaction.netAmount ?? 0;
    this.totalInWords = this.numberToWords(this.totalNet);
    return;
  }

  // grouped totals
  this.groups = this.buildGroups(data.details);
  const r2 = (n: number) => Math.round(n * 100) / 100;

  this.totalAmount    = r2(this.groups.reduce((s, g) => s + g.amount, 0));
  this.totalTaxAmount = r2(this.groups.reduce((s, g) => s + g.tax, 0));
  this.totalNet       = r2(this.groups.reduce((s, g) => s + g.net, 0));
  this.totalInWords   = this.numberToWords(this.totalNet);
}

  // private paginate(data: any): void {
  //   const details = data.details.length ? data.details : [null as any];
  //   const chunks: (any | null)[][] = [];

  //   for (let i = 0; i < details.length; i += ROWS_PER_PAGE) {
  //     chunks.push(details.slice(i, i + ROWS_PER_PAGE));
  //   }

  //   this.pages = chunks.map((chunk, chunkIdx) => {
  //     // pad each page to ROWS_PER_PAGE
  //     const padded = [...chunk];
  //     while (padded.length < ROWS_PER_PAGE) padded.push(null);

  //     const rows: any[] = padded.map((detail, i) => {
  //       const tx = data.transaction;
  //       const tax = detail && tx ? (detail.amount ?? 0) * ((tx.taxPercentage ?? 0) / 100) : 0;
  //       const net = detail ? (detail.amount ?? 0) + tax : 0;
  //       return { detail, transaction: tx ?? null, taxAmount: tax, netAmount: net, index: i };
  //     });

  //     return {
  //       rows,
  //       isFirst: chunkIdx === 0,
  //       isLast: chunkIdx === chunks.length - 1,
  //       pageNumber: chunkIdx + 1,
  //     };
  //   });
  // }

  private paginateFlat(data: any): void {
  const details = data.details.length ? data.details : [null as any];
  const chunks: any[][] = [];

  for (let i = 0; i < details.length; i += ROWS_PER_PAGE) {
    chunks.push(details.slice(i, i + ROWS_PER_PAGE));
  }

  this.pages = chunks.map((chunk, chunkIdx) => {
    const padded = [...chunk];
    while (padded.length < ROWS_PER_PAGE) padded.push(null);

    return {
      rows: padded.map((detail, idx) => ({
        type: detail ? 'detail' : 'empty',
        detail,
        index: idx,
      })),
      isFirst: chunkIdx === 0,
      isLast: chunkIdx === chunks.length - 1,
      pageNumber: chunkIdx + 1,
    };
  });
}


private paginate(data: any): void {
   if (!this.hasTags) { this.paginateFlat(data); return; }
  // flatten: tag header -> details -> tag subtotal
  const flat: any[] = [];
  for (const g of this.groups) {
    const isNoTag = g.tagId === 0; // same NO_TAG key used in buildGroups

    if (!isNoTag)
      flat.push({ type: 'tag', tagName: g.tagName, count: g.count });

    g.items.forEach((d: any) => flat.push({ type: 'detail', detail: d }));

    if (!isNoTag) flat.push({ type: 'subtotal', group: g });
  }

  const pageRows: any[][] = [];
  let cur: any[] = [];
  const pad = () => { while (cur.length < ROWS_PER_PAGE) cur.push({ type: 'empty' }); };
  const flush = () => { pad(); pageRows.push(cur); cur = []; };

  for (const row of flat) {
    // don't leave a tag header orphaned at the bottom of a page
    if (row.type === 'tag' && cur.length > ROWS_PER_PAGE - 3) flush();
    if (cur.length === ROWS_PER_PAGE) flush();
    cur.push(row);
  }
  if (cur.length || !pageRows.length) flush();

  // this.pages = pageRows.map((rows, i) => ({
  //   rows: rows.map((r, idx) => ({ ...r, index: idx })),
  //   isFirst: i === 0,
  //   isLast: i === pageRows.length - 1,
  //   pageNumber: i + 1,
  // }));
  this.pages = pageRows.map((rows, i) => {
  const isLast = i === pageRows.length - 1;
  const visible = isLast ? rows.filter(r => r.type !== 'empty') : rows;

  return {
    rows: visible.map((r, idx) => ({ ...r, index: idx })),
    isFirst: i === 0,
    isLast,
    pageNumber: i + 1,
  };
});
}


  // ── Template helpers ──────────────────────────────────────────────────────
  fmtNumber(n: number | null | undefined, decimals = 2): string {
    if (n == null) return '-';
    return n.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }

  fmtCurrency(n: number | null | undefined): string {
    if (n == null) return '-';
    return `${this.currency} ${this.fmtNumber(n)}`;
  }

  fmtDate(iso: string | null | undefined): string {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString('en-GB', {
      day: '2-digit', month: '2-digit', year: 'numeric',
    });
  }

  trackByPage(_: number, page: any): number {
    return page.pageNumber;
  }

  trackByRow(_: number, row: any): number {
    return row.index;
  }

  // ── Actions ───────────────────────────────────────────────────────────────
  print(): void {
    window.print();
  }

  async downloadPdf(): Promise<void> {
    this.generatingPdf = true;
    try {
      const [{ default: jsPDF }, { default: html2canvas }] = await Promise.all([
        import('jspdf'),
        import('html2canvas'),
      ]);

      const pagesEl = document.getElementById('report-pages');
      if (!pagesEl) return;

      const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const pageEls = pagesEl.querySelectorAll<HTMLElement>('.page');

      for (let i = 0; i < pageEls.length; i++) {
        const canvas = await html2canvas(pageEls[i], { scale: 2, useCORS: true });
        const imgData = canvas.toDataURL('image/png');
        const pdfW = pdf.internal.pageSize.getWidth();
        const pdfH = (canvas.height * pdfW) / canvas.width;
        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, 0, pdfW, pdfH);
      }

      const filename = `expense_reimbursement_${Date.now()}.pdf`;
      pdf.save(filename);
    } catch (e) {
      console.error('PDF generation error', e);
    } finally {
      this.generatingPdf = false;
    }
  }

  // ── Utility: number → English words ──────────────────────────────────────
  private numberToWords(n: number): string {
    if (!n) return 'Zero';
    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven',
      'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen',
      'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty',
      'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const say = (x: number): string => {
      if (x < 20) return ones[x];
      if (x < 100) return tens[Math.floor(x / 10)] + (x % 10 ? ' ' + ones[x % 10] : '');
      return ones[Math.floor(x / 100)] + ' Hundred' + (x % 100 ? ' ' + say(x % 100) : '');
    };

    const whole = Math.floor(n);
    const cents = Math.round((n - whole) * 100);
    let w = '';
    if (whole >= 1_000_000) w += say(Math.floor(whole / 1_000_000)) + ' Million ';
    if (whole >= 1_000) w += say(Math.floor((whole % 1_000_000) / 1_000)) + ' Thousand ';
    if (whole % 1_000) w += say(whole % 1_000);
    w = (w.trim() || 'Zero');
    return `${w} ${this.currency}${cents ? ` and ${cents}/100` : ' Only'}`;
  }

  getSignatureSrc(signature: string | null | undefined): string {
    if (!signature) return '';
    if (signature.startsWith('data:image')) return signature;
    return `data:image/png;base64,${signature}`;
  }
}